import React, { Component } from 'react'
import './ButtonWarning.css'

export default class ButtonWarning extends Component {
    render() {
        return (
            <button {...this.props} className={"btn-tertium-warning "+this.props.className}>{ this.props.children }</button>
        )
    }
}